module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/announcement_footer.8acdbdee.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/AnnouncementsCard/images/announcement_footer.png
// module id = 2884
// module chunks = 11